import React from 'react'
import AppModal from '../common/AppModal'
import CreateOrUpdateBrandForm from '../../forms/CreateOrUpdateBrandForm'

interface CreateBrandModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const CreateBrandModal: React.FC<CreateBrandModalProps> = ({ open, onClose, loading, error }) => (
  <AppModal open={open} onClose={onClose} title="Add New Brand" width="sm" loading={loading}>
    <CreateOrUpdateBrandForm loading={loading} error={error} />
  </AppModal>
)
export default CreateBrandModal
